import { ChangeDetectorRef, Component } from '@angular/core';
import { ICellEditorAngularComp } from 'ag-grid-angular';
import * as moment from 'moment';

@Component({
    selector: 'app-input-cell-editor',
    template: `
    <div class="custom-renderer-ag">
         <input type="datetime-local" class="form-control form-ctrl" style="border-bottom: inherit !important;" [min]="minDateTime" [disabled]="params.node.data.isDatepickerDisabled" [(ngModel)]="selectedValue" (change)="onValueChange($event)">
</div>
  `,
})
export class DatepickerCellRenderer1 implements ICellEditorAngularComp {
    params: any;
    public selectedValue: any;
    public minDateTime: string;

    agInit(params: any): void {
        this.minDateTime = moment().format('YYYY-MM-DDTHH:mm');
        this.params = params;
        this.selectedValue = params.value;
    }

    refresh(params: any) {
        this.params = params;
        return true;
    }

    getValue(): any {
        return this.selectedValue;
    }

    isPopup(): boolean {
        return true; // Return true if you want popup editing style
    }

    // Optional methods
    // You can add additional methods like focusIn, focusOut, etc. as needed

    onValueChange(newValue: any): void {
        this.params.setValue(newValue.target.value);
        // this.params.api.stopEditing();
    }

    // Implement other necessary methods from ICellEditorAngularComp interface
}
